import React, { useMemo } from 'react';
import { useAtomValue, useAtom } from 'jotai';
import { Form, Select, Switch } from 'antd';
import Icon from '@ant-design/icons';
import ToothedGearSvg from '@icons/toothed-gear.svg';
import { AppThresholds } from '@src/utils/kpi/app';
import kpiStore from '@globalStore/kpiStore';
import { editModeAtom, selectedKpiThresholdsAtom } from '../atoms';
import { StyledFormField, StyledFormLabel, StyledSelect, StyledAnd, StyledSwitch } from '../styled';

const { Option } = Select;

const FieldElement: React.FC<{
  thresholdKey: string;
  thresholdValue: string;
  kpiIndex: number;
}> = ({ thresholdKey, thresholdValue, kpiIndex }) => {
  const { kpiMetaConfigs } = kpiStore((state: any) => state);
  const editMode = useAtomValue(editModeAtom);
  const [selectedKpiThresholds, setSelectedKpiThresholds] = useAtom(selectedKpiThresholdsAtom);

  const onThresholdChange = (value) => {
    setSelectedKpiThresholds({ ...selectedKpiThresholds, [thresholdKey]: value });
  };
  const thresholdDetails = kpiMetaConfigs[thresholdKey] || {};

  const isBadEvents = useMemo(
    () => thresholdKey === AppThresholds.AppSPIBadEventsThreshold,
    [thresholdKey],
  );

  const isANR = useMemo(() => thresholdKey === AppThresholds.AppSPIANRThreshold, [thresholdKey]);

  const onClickBadEventIcon = () => {
    window.open(`/app/activation/management/bad-events`, '_blank');
  };

  if (isBadEvents) {
    return (
      <Form.Item key={thresholdKey}>
        <StyledFormField>
          <StyledAnd>{kpiIndex > 0 ? <span>AND</span> : null}</StyledAnd>
          <StyledFormLabel>
            <p>
              {thresholdDetails.displayName}
              <Icon
                component={ToothedGearSvg}
                style={{
                  fontSize: '20px',
                  background: '#F2F6FF',
                  padding: '2px',
                  marginLeft: '8px',
                  borderRadius: '3px',
                  cursor: 'pointer',
                }}
                onClick={onClickBadEventIcon}
              />
            </p>
            <span>{thresholdDetails.caption}</span>
          </StyledFormLabel>
          <StyledSwitch>
            <Switch
              checked={Number(thresholdValue) === 1}
              onChange={(e) => onThresholdChange(e ? 1 : 0)}
              disabled={!editMode || !thresholdDetails.available}
            />
          </StyledSwitch>
        </StyledFormField>
      </Form.Item>
    );
  }

  return (
    <Form.Item key={thresholdKey}>
      <StyledFormField>
        <StyledAnd>{kpiIndex > 0 ? <span>AND</span> : null}</StyledAnd>
        <StyledFormLabel>
          <p>{thresholdDetails.displayName}</p>
          <span>{thresholdDetails.caption}</span>
        </StyledFormLabel>
        <StyledSelect>
          <span className="threshold-condition">{thresholdDetails.threshold}</span>
          <Select
            value={isANR ? 1 : thresholdValue}
            style={{ width: 70 }}
            onChange={(e) => onThresholdChange(e)}
            disabled={!editMode || isANR}
          >
            {thresholdDetails.bucket.map((option) => {
              return (
                <Option key={option} value={option}>
                  {option}
                </Option>
              );
            })}
          </Select>
          <span className="threshold-units">{thresholdDetails.unit}</span>
        </StyledSelect>
      </StyledFormField>
    </Form.Item>
  );
};

export default FieldElement;
